import { render } from "./RecipientPhenotypeComponent.vue?vue&type=template&id=1c530d48&scoped=true"
import script from "./RecipientPhenotypeComponent.vue?vue&type=script&lang=js"
export * from "./RecipientPhenotypeComponent.vue?vue&type=script&lang=js"

import "./RecipientPhenotypeComponent.vue?vue&type=style&index=0&id=1c530d48&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c530d48"]])

export default __exports__